import { createContext, useCallback, useState } from "react";

const ModalContext = createContext();

export const ModalContextProvider = ({ children }) => {
    const [modal, setModal] = useState(false);

    // ModalShell handler - props can only be boolean!
    //
    // Postojan: dijalozi ga drže u `useEffect`-u koji zatvara prozor po
    // uspehu. Da se pravi iznova, effect bi se okidao pri svakom iscrtavanju i
    // zakazivao novi `setTimeout` za zatvaranje.
    const handleModal = useCallback((value) => {
        setModal(typeof value === "boolean" ? value : false);
    }, []);

    const valueToShare = {
        modal,
        handleModal
    }

    return (
        <ModalContext.Provider value={valueToShare}>
            {children}
        </ModalContext.Provider>
    );
}

export default ModalContext;